import React, { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import "../../../styles/admins/invoices/invoice.css";
import { useNavigate } from "react-router-dom";
import convertAmountToWords from "../../confs/amount_words";

const rowOne = { width: "7%", textAlign: "center" };
const rowTwo = { width: "46%" };
const rowThree = { width: "20%" };
const rowFour = { borderRight: "none", width: "20%", textAlign: "right" };

function GRCPrint(props) {
  console.log(props);
  const contentRef = useRef();
  const navigate = useNavigate();
  const reactToPrintFn = useReactToPrint({
    contentRef,
    onAfterPrint: () => {
      setTimeout(() => {
        if (props.isReprint) {
          navigate(-1);
        } else {
          props.toggleHeader();
          localStorage.removeItem("rooms");
          localStorage.removeItem(
            `food_order_${props.invoiceDetails.booking_id}`
          );
          navigate("/admin/rooms", { replace: true });
        }
      }, 400);
    },
  });


    const hotelDetail = props.clientDetails;
console.log(hotelDetail);

  window.onpopstate = (e) => {
    localStorage.removeItem("rooms");
    window.location.reload();
  };

  const clientIs = localStorage.getItem("client_is");
  const clientDetails = JSON.parse(clientIs);

  const guests = JSON.parse(localStorage.getItem("guests"));
  const rooms = JSON.parse(localStorage.getItem("rooms"));

  const getRoomTypeById = (id) => {
    if (!rooms || !Array.isArray(rooms)) return "PREMIUM";
    const room = rooms.find((r) => r.room_id === id);
    return room ? room.room_type : "PREMIUM";
  };

  // Function to get guest details by guestId
  const getGuestDetails = (guestId) => {
    const guest = guests.find((g) => g.id === guestId);
      console.log(guest);

    if (guest) {
      if (guest.is_com) {
        guest.name = JSON.parse(props.invoiceDetails.guest_data).name[0];
        var guestName = "";
        const Gname = guest.name.split(",");
        if (Gname.length > 1) {
          guestName = Gname[1];
          for (let i = 2; i < Gname.length; i++) {
            guestName = guestName + "," + Gname[i];
          }
        }
        return {
          name: Gname[0],
          guest_name: guestName,
          contact: guest.contact,
          comp_contact: guest.comp_contact ?? "",
          address: guest.address,
          is_com: guest.is_com,
          identity_proof: guest.identity_proof
        };
      } else {
        return {
          name: guest.name,
          contact: guest.contact,
          address: guest.address,
          is_com: guest.is_com,
          identity_proof: guest.identity_proof
        };
      }
    } else {
      return {
        name: JSON.parse(props.invoiceDetails.guest_data).name[0],
        contact: "",
      };
    }
  };

  const guestData = getGuestDetails(
    JSON.parse(props.invoiceDetails.guest_data).id[0]
  );



  const calculateDaysDifference = (from, to) => {
    if (!from || !to) return 0;
    const fromDate = new Date(from);
    const toDate = new Date(to);
    const timeDifference = toDate - fromDate;
    return Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
  };

  // const sumof = (arr) => {
  //   return arr.reduce((acc, curr) => acc + parseFloat(curr), 0);
  // };

  function formatDate(dateString) {
  const date = new Date(dateString);

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
}

function formatTime(dateString) {
  const date = new Date(dateString);

  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";

  hours = hours % 12 || 12;

  return `${hours}:${minutes} ${ampm}`;
}


  return (
    <section className="d-flex flex-column align-items-center">
      <div
        className="invoice-outer col-lg-6 col-md-10 col-12 inv"
        ref={contentRef}
      >
        <div className="invoice-container">
          <div className="d-flex align-items-center mr-1">
            <img
              src={clientDetails.image}
              alt=""
              style={{
                height: "90px",
                width: "90px",
                marginRight: "15px",
                marginLeft: "40px",
              }}
            />
            <div className="invoice-header">
              <h2 style={{ fontSize: "30px" }}>
                {clientDetails.business_name.toUpperCase()}
              </h2>
              {clientDetails.tagline && (
                <p>{clientDetails.tagline.toUpperCase()}</p>
              )}
              <p>{clientDetails.address.toUpperCase()}</p>
              <p style={{ fontSize: "15.5px" }}>
                Contacts: {clientDetails.contact}
              </p>
              {clientDetails.email && (
                <p style={{ fontSize: "14px", marginBottom: "8px" }}>
                  {clientDetails.email}
                </p>
              )}
              <h2 style={{ fontSize: "18px" }}>Guest Registration Form</h2>
            </div>
          </div>

          <div className="invoice-details">
            <div className="registrations">
                              {hotelDetail.gstin_show == 1 ?
              clientDetails.gstin !== null && (
                <p>GSTIN: {clientDetails.gstin}</p>
              ): (<p></p>)
            }
              {clientDetails.fssai !== null && clientDetails.fssai && (
                <p>FSSAI No.: {clientDetails.fssai}</p>
              )}
              {clientDetails.oyo_reg !== null && clientDetails.oyo_reg && (
                <p>OYO Reg No.: {clientDetails.oyo_reg}</p>
              )}
            </div>
            <div className="client-details">
              <div className="invoice-meta text-start">
                <p>
                  Company Name: <b>{guestData.is_com ? guestData.name : ""}</b>
                </p>
                <p>Company GST: {guestData.is_com ? guestData.contact : ""}</p>
                <p>
                  Guest Name:&nbsp;
                  <b>
                    {guestData.is_com ? guestData.guest_name : guestData.name}
                  </b>
                </p>
                <p>
                  Guest Contact:{" "}
                  {guestData.is_com
                    ? guestData.comp_contact
                    : guestData.contact}
                </p>
                {clientDetails.id === 6 && (
                  <p style={{ height: "42px" }}>Address: {guestData.address}</p>
                )}
              </div>
              <div className="invoice-meta text-start">
                <p>
                  Invoice No:{" "}
                  {props.multiBills && props.multiBills.length > 1
                    ? props.multiBills[0].inv_no < 10
                      ? `00${props.multiBills[0].inv_no}`
                      : props.multiBills[0].inv_no < 100
                      ? `0${props.multiBills[0].inv_no}`
                      : props.multiBills[0].inv_no
                    : props.invoiceDetails.inv_no < 10
                    ? `00${props.invoiceDetails.inv_no}`
                    : props.invoiceDetails.inv_no < 100
                    ? `0${props.invoiceDetails.inv_no}`
                    : props.invoiceDetails.inv_no}
 &nbsp;&nbsp;|&nbsp; FY&nbsp;
  {
    (() => {
      const year = parseInt(props.invoiceDetails.to_date.slice(0, 4));
      const month = parseInt(props.invoiceDetails.to_date.slice(5, 7));
      const fyStart = month < 4 ? year - 1 : year;
      const fyEnd = fyStart + 1;
      return `${fyStart.toString().slice(-2)}-${fyEnd.toString().slice(-2)}`;
    })()
  }                </p>
                  <p>
                  Id Proof:{" "}
                  {guestData.identity_proof}
                </p>
                {clientDetails.id === 6 && (
                  <p>
                    Entry No:&nbsp;&nbsp;
                    {props.invoiceDetails.remarks}
                  </p>
                )}
                {/* <p>
                  Room No:{" "}
                  {props.multiBills && props.multiBills.length > 1
                    ? props.multiBills.map((b) => b.room_no).join(", ")
                    : props.invoiceDetails.room_no}
                </p>
                <b>
                  <p>
                    Checkin: &nbsp;&nbsp;&nbsp;
                    {props.invoiceDetails.from_date.slice(8, 10)}-
                    {props.invoiceDetails.from_date.slice(5, 7)}-
                    {props.invoiceDetails.from_date.slice(0, 4)}{" "}
                    {props.invoiceDetails.from_date.slice(11, 16)}
                  </p>
                </b>
                <b>
                  <p>
                    Checkout: {props.invoiceDetails.to_date.slice(8, 10)}-
                    {props.invoiceDetails.to_date.slice(5, 7)}-
                    {props.invoiceDetails.to_date.slice(0, 4)}{" "}
                    {props.invoiceDetails.to_date.slice(11, 16)}
                  </p>
                </b> */}
              </div>
            </div>
            {clientDetails.id !== 6 && (
              <div style={{ height: "48px" }}>
                <p className="address-line">Address: {guestData.address}</p>
              </div>
            )}
            <div
              style={{
                height: "380px",
                borderBottom: "1px solid #000000",
                position: "relative",
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundImage: `url(${clientDetails.image})`,
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                  backgroundSize: "270px",
                  opacity: 0.2, // Sets only the background opacity
                  zIndex: 0, // Ensure it's behind the content
                }}
              ></div>

<div className="invoice-meta px-1">
                <b>
              <p className="my-0">Room No: {props.multiBills && props.multiBills.length > 1
                    ? props.multiBills.map((b) => b.room_no).join(", ")
                    : props.invoiceDetails.room_no}</p></b>

                <b className="d-flex justify-content-between">
                  <p className="my-0">
                    Checkin Date: &nbsp;&nbsp;
                    {formatDate(props.invoiceDetails.from_date)}
                    {/* {props.invoiceDetails.from_date.slice(8, 10)}-
                    {props.invoiceDetails.from_date.slice(5, 7)}-
                    {props.invoiceDetails.from_date.slice(0, 4)}{" "}
                    {props.invoiceDetails.from_date.slice(11, 16)} */}
                  </p>

                  <p className="my-0">
                    Checkin Time: &nbsp;&nbsp;
{formatTime(props.invoiceDetails.from_date)}</p>


                </b>
                
                {/* <b className="d-flex justify-content-between">
                  <p className="my-0">
                    Checkout Date: &nbsp;&nbsp;
{formatDate(props.invoiceDetails.to_date)} */}
                    {/* {props.invoiceDetails.to_date.slice(8, 10)}-
                    {props.invoiceDetails.to_date.slice(5, 7)}-
                    {props.invoiceDetails.to_date.slice(0, 4)}{" "}
                    {props.invoiceDetails.to_date.slice(11, 16)} */}
                  {/* </p>

                                    <p className="my-0">
                    Checkout Time: &nbsp;&nbsp;
{formatTime(props.invoiceDetails.from_date)}</p>

                </b> */}

<br />

                <p className="my-0">
                  Total Adults&nbsp;:{" "}
                  {props.multiBills && props.multiBills.length > 1
                    ? props.multiBills.reduce(
                        (sum, b) => sum + parseInt(b.no_of_stayers),
                        0
                      )
                    : props.invoiceDetails.no_of_stayers}
                </p>

                <span className="d-flex justify-content-between">
                                    {parseFloat(props.invoiceDetails.advance_amount) > 0 && (
                  <p className="my-0">
                    Advance Paid:&nbsp;&nbsp; ₹{" "}
                    {props.invoiceDetails.advance_amount}
                  </p>
                )}

              <p className="my-0">
                Rate:&nbsp;&nbsp; ₹{" "}
                {(
                  parseFloat(props.invoiceDetails.total_amount) -
                  parseFloat(props.invoiceDetails.discount) +
                  (props.printExtra
                    ? parseFloat(props.invoiceDetails.extra_charges)
                    : 0) +
                  (props.printFood
                    ? parseFloat(props.invoiceDetails.food_price)
                    : 0) +
                  (props.printFood
                    ? parseFloat(props.invoiceDetails.food_tax_amount)
                    : 0) +
                  parseFloat(props.invoiceDetails.tax_amount)
                ).toFixed(0)}
                .00
              </p>

                </span>


<p className="my-0">
Payment Mode: {props.invoiceDetails.payment_method
  ? props.invoiceDetails.payment_method.includes(" | ")
    ? props.invoiceDetails.payment_method.split(" | ")[0]
    : props.invoiceDetails.payment_method
  : "Pending"}
    {/* Payment Mode: {props.invoiceDetails.payment_method.includes(" | ") 
      ? props.invoiceDetails.payment_method.split(" | ")[0]
      : props.invoiceDetails.payment_method} */}

  {props.invoiceDetails.payment_method.includes(" | ") && (
    <div
    >
      {props.invoiceDetails.payment_method
        .split(" | ")
        .slice(1)
        .map((item, i) => {
          const [method, amount] = item.split("-");
          return (
            <div
              key={i}
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "2px",
              }}
            >
              <span>{method}</span>
              <span>₹{amount}</span>
            </div>
          );
        })}
        </div>
        )}
</p>


</div>
            </div>



            <div className="footer-data">
              <div className="left-foot" style={{ paddingBottom: "5px 0" }}>
                <strong style={{ textAlign: "start" }}>
                  <pre style={{ margin: "0", fontSize: "12px" }}>
                    {clientDetails.footer_contents}
                  </pre>
                </strong>
                <p
                  style={{
                    marginTop: "30px",
                    marginLeft: "25px",
                  }}
                >
                  Guest Signature
                </p>
              </div>
              <div className="right-foot">
                <p>For {clientDetails.business_name}</p>
                {clientDetails.sign_image && (
                  <img
                    src={clientDetails.sign_image}
                    alt="Signature"
                    height={"80px"}
                    width={"140px"}
                  />
                )}
                <p>Authorised Signature</p>
              </div>
            </div>
            {/* <p
              style={{
                textAlign: "center",
                fontWeight: "500",
                marginBottom: "2px",
              }}
            >
              !! Thank you for your stay !!
            </p> */}
          </div>

          {/* Print Button */}
        </div>
      </div>
      <br />

            <div className="d-flex">
<button
  className="print-btn me-3"
 onClick={() => props.setShowGrc(false)}>
  Go Back
</button>
      <button className="print-btn" onClick={reactToPrintFn}>
        Print Invoice
      </button>
      </div>
    </section>
  );
}

export default GRCPrint;
